<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <GridTable v-if="items && items.length" :columns="columns" :rows="items" class="col-12">
        <template #row="{row}">
          <GridTableCell>{{ formatDateTimeForLocale(row.created_at) }}</GridTableCell>
          <GridTableCell>{{ row.description }}</GridTableCell>
          <GridTableCell>{{ row.decision }}</GridTableCell>
        </template>
      </GridTable>
    </template>
  </milestone-wrapper>
</template>

<script>
// Libraries
import { get, cloneDeep, orderBy } from 'lodash'
// Components
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    MilestoneWrapper,
    GridTable,
    GridTableCell
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      email: null
    }
  },
  computed: {
    items() {
      let entries = cloneDeep(get(this, 'data.content'))
      return orderBy(entries, ['created_at'], ['desc'])
    },

    columns() {
      return [
        { label: 'Date', width: '150px', align: 'center' },
        { label: 'Description', width: '1fr' },
        { label: 'Decision', width: '1fr' }
      ]
    }
  }
}
</script>
